// Any link leaving the shop opens a tab of its own, so a customer mid-browse
// never loses the site. Menu links and links typed into richtext are set in
// admin, with nowhere to put an attribute — hence a sweep rather than markup.
//
// Left alone: links that already name a target, and the video triggers, whose
// href is a fallback the player intercepts.
const SKIP = 'a[target], [data-video-trigger]';

function sweep(root) {
  for (const a of root.querySelectorAll('a[href]')) {
    if (a.matches(SKIP) || a.closest('[data-video-trigger]')) continue;

    let url;
    try {
      url = new URL(a.href, location.href);
    } catch {
      continue;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') continue;
    if (url.host === location.host) continue;

    a.target = '_blank';
    if (!a.rel.split(/\s+/).includes('noopener')) {
      a.rel = a.rel ? `${a.rel} noopener` : 'noopener';
    }

    // screen readers get the same warning the hand-written links carry
    if (!a.querySelector('.visually-hidden')) {
      const note = document.createElement('span');
      note.className = 'visually-hidden';
      note.textContent = ' (opens in a new tab)';
      a.append(note);
    }
  }
}

sweep(document);

// sections re-render on their own in the editor and through the Section
// Rendering API, so new markup gets the same treatment
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType === 1) sweep(node.parentNode || node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
